import { Error } from '../../Form/Fields/Types';

const emailRegex = /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/;
const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
const alphabeticalRegex = /[^A-Za-z]/g;

class FieldValidators {
  static validateEmail(email: string): Error {
    if (!emailRegex.test(email)) {
      return 'Email is invalid.';
    }
  }

  static validatePassword(password: string): Error {
    if (!passwordRegex.test(password)) {
      return 'Password must be at least 8 characters, with at least one lowercase letter, one uppercase letter, and 1 number.';
    }
  }

  static validateGivenName(givenName: string): Error {
    if (!givenName || !this.removePunctuationAndSpacing(givenName)) {
      return 'First name cannot be left blank.';
    }
  }

  static validateFamilyName(familyName: string): Error {
    if (!familyName || !this.removePunctuationAndSpacing(familyName)) {
      return 'Last name cannot be left blank.';
    }
  }

  static validateName(name: string): boolean {
    return !name || !this.removePunctuationAndSpacing(name);
  }

  static removePunctuationAndSpacing(str: string): string {
    return str.replace(alphabeticalRegex, '');
  }
}

export default FieldValidators;
